export default __webpack_public_path__ + "static/media/137.e32c3d73.gif";